import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b0e5f3b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "privacy-policy-modal-title" };
const _hoisted_2 = { class: "privacy-policy-modal-content-inner" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "button-container mt50" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BasicButton = _resolveComponent("BasicButton");
    const _component_ModalContainer = _resolveComponent("ModalContainer");
    return (_openBlock(), _createBlock(_component_ModalContainer, { "modal-content-class": "privacy-policy-modal-content" }, {
        default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('message.terms_personal_privacy')), 1),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                    innerHTML: _ctx.privacyPolicyTerms?.terms_contents
                }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_BasicButton, {
                    "color-type": _ctx.BASIC_BUTTON_COLOR_TYPE.PRIMARY,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
                    ]),
                    _: 1
                }, 8, ["color-type"])
            ])
        ]),
        _: 1
    }));
}
